import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';

const networkOptions = [
    {
        name: 'Ethernet',
        value: '1',
    },
    {
        name: 'WiFi',
        value: '2',
    },
    {
        name: 'Cellular',
        value: '3',
    },
];


export default class NetworkChangedNode extends BaseNode {
    constructor() {
        super();
        this.name = 'On Network Changed';
        this.id = 'node_network_changed';
        this.icon = 'VscDebugDisconnect';
        this.linkedFeature = 'general';
        this.requirements = ['network'];

        this.outputs = [
            {
                name: '',
                portId: 'network_changed',
                params: [],
            },
        ];


        const settings: Setting[] = [
            {
                id: 'NETWORK_TYPE',
                name: 'Network Type',
                settingType: SettingType.OPTION,
                required: true,
                default: '1',
                options: networkOptions,
            },
            {
                id: 'NETWORK_EVENT',
                name: 'Change Type',
                settingType: SettingType.OPTION,
                required: true,
                default: '1',
                options: [
                    {
                        name: 'Connected',
                        value: '1',
                    },
                    {
                        name: 'Disconnected',
                        value: '0',
                    },
                ],
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getDependencies(): string[] {
        const NETWORK_TYPE = this.getSettingValue('NETWORK_TYPE');
        if (NETWORK_TYPE === 'wifi') {
            return ['wifi'];
        }
        if (NETWORK_TYPE === 'cell') {
            return ['cell'];
        }
        return [];
    }

    getSettingValue(settingId: string): string {
        if (settingId === 'DISPLAY_NAME') {
            const value = super.getSettingValue(settingId);
            if (value !== '') {
                return value;
            }
            const NETWORK_TYPE = this.getSettingValue('NETWORK_TYPE');
            const NETWORK_EVENT = this.getSettingValue('NETWORK_EVENT');
            if (NETWORK_TYPE) {
                let network_name;
                for (let i = 0; i < networkOptions.length; i++) {
                    if (networkOptions[i].value === NETWORK_TYPE) {
                        network_name = networkOptions[i].name;
                    }
                }
                const eventName = NETWORK_EVENT === '1' ? 'Connected' : 'Disconnected';
                return `On {{$${network_name}}} ${eventName}`;
            }
        }
        return super.getSettingValue(settingId);
    }

    getCodeBlocks(): CodeBlock[] {
        const blocks: CodeBlock[] = [];
        const project: ProjectConfiguration = this.project;
        const NETWORK_TYPE = this.getSettingValue('NETWORK_TYPE');
        const NETWORK_EVENT = this.getSettingValue('NETWORK_EVENT');

        const links = project.getNodeLinks(this, 'network_changed');
        if (links.length > 0) {
            for (let i = 0; i < 1; i++) {
                const link = links[i];
                if (project.runtime === 'micropython') {
                    blocks.push({
                        location: 'interface_set',
                        blockType: BlockType.CODE,
                        id: link.getSourceId(),
                        template: `
if (interface == ${NETWORK_TYPE} and state == ${NETWORK_EVENT}):
    #****${link.getSourceId()}****#
    pass`,
                    });
                } else if (project.runtime === 'zephyr') {
                    blocks.push({
                        location: 'interface_set',
                        blockType: BlockType.CODE,
                        id: link.getSourceId(),
                        template: `
if (interface == ${NETWORK_TYPE} && state == ${NETWORK_EVENT}) {
    /****${link.getSourceId()}****/
}`,
                    });
                } else {
                    blocks.push({
                        location: 'interface_set',
                        blockType: BlockType.CODE,
                        id: link.getSourceId(),
                        template: `
    if interface=${NETWORK_TYPE} AND state=${NETWORK_EVENT} then
        '****${link.getSourceId()}****'
    end if`,
                    });
                }
            }
        }
        return blocks;
    }

    getDetails(): string {
        return `
`;
    }
}
